/*
    Filter for choosing which trip on time records to display,
    based on location, route, run, lane, starter, and time range

    If the user has previously submitted filter values for this report
    during this session, those will be set on load
*/

import React from "react";

import MainContext from "../MainContext";

import LocationDropDown from "../Components/LocationDropDown";
import DateInput from "../Components/DateInput";
import TimeInput from "../Components/TimeInput";
import StyledCheckbox from "../Components/StyledCheckbox";
import MultiSelect from "../Components/MultiSelect";

import { getRoutes } from "../Requests/UtilityRequests";

/*
Location
Route(multi)
Start Date
Start Time
End Date
End Time
Valid From Time
Valid To Time
Weekdays check (true)
Weekends check (true)
*/

//
// initial filter values, as well as what to set to on reset
//
function getDefaultState() {
    return {
        location: "",
        startDate: new Date(),
        endDate: new Date(),
        startTime: "00:00",
        endTime: "23:59",
        validFrom: "00:00",
        validTo: "23:59",
        weekdays: true,
        weekends: true,
        showDailyResult: false,
        useRealTime: false,
        routes: [],
        routesSelected: []    
    };
}

export default class ReportTripOnTimeFilter extends React.Component {

    static contextType = MainContext;

    state = getDefaultState();

    //
    //
    updateValue = (evt) => {
        const targetName = evt.target.name;
        this.setState({[evt.target.name]: evt.target.value}, () => {
            if(targetName === "location"){
                this.locationSelected();
            }
        });
    }

    //
    //
    applyFilter = () => {
        const values = {...this.state};

        console.log("filter values", values);
        
        this.props.applyFilter(values, this.props.toggleFilter);
        this.context.updateReportFilter(values);
    }

    //
    //
    resetFilter = () => {
        this.setState(getDefaultState());
    }

    //
    // when a location is selected, cascade to fill in routes
    //
    locationSelected = () => {
        this.fillRoutes();
    }

    //
    //
    fillRoutes = () => {
        const request = () => getRoutes(this.state.location);
        const then = ({data}) => {
            const cleaned = data.map(v => v.Route);
            this.setState({routes: cleaned, routesSelected: []});
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    //
    // set the filter values
    //
    componentDidMount(){
        if(this.props.filterValues){
            this.setState({...this.props.filterValues});
        }
        else if(this.context.reportFilterValues){
            console.log("WE HAVE REPORT VALUES", this.context.reportFilterValues);
            const copy = {...this.state};
            for(let key in copy) {
                if(this.context.reportFilterValues.hasOwnProperty(key)){
                    copy[key] = this.context.reportFilterValues[key];
                }
            }
            this.setState(copy);
        }
    }

    render(){

        const isBus = this.context.user.groupid === "BUS";

        return (
            <div className="filter">
                <div className="form-element-horizontal">
                    <label>Location</label>
                    <LocationDropDown
                        setFocus={true}
                        selected={this.state.location} 
                        updateValue={this.updateValue}
                        hasAllOption={true} />
                </div>
                <div className="form-element-horizontal">
                    <label>Start Date</label>
                    <div>
                        <DateInput 
                            name="startDate"
                            value={this.state.startDate}
                            onChange={this.updateValue}
                        />
                        <TimeInput name="startTime" value={this.state.startTime} onChange={this.updateValue} />
                    </div>
                </div>
                <div className="form-element-horizontal">
                    <label>End Date</label>
                    <div>
                        <DateInput 
                            name="endDate"
                            value={this.state.endDate}
                            onChange={this.updateValue}
                        />
                        <TimeInput name="endTime" value={this.state.endTime} onChange={this.updateValue} />
                    </div>
                </div>
                <div className="form-element-horizontal">
                    <label>Valid Times</label>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr"                    
                    }}>
                        <div>
                            <label style={{marginRight:"4px"}}>From</label>
                            <TimeInput name="validFrom" value={this.state.validFrom} onChange={this.updateValue} />
                        </div>

                        <div>
                            <label style={{marginRight:"4px"}}>To</label>
                            <TimeInput name="validTo" value={this.state.validTo} onChange={this.updateValue} />
                        </div>
                    </div>
                </div>

                <div className="form-element-row" style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    gripGap: "4px"
                }}>
                    <StyledCheckbox 
                        name="weekdays" 
                        label="Valid on Weekdays?" 
                        checked={this.state.weekdays} 
                        onChange={() => this.setState({weekdays: !this.state.weekdays})} 
                    />
                    <StyledCheckbox 
                        name="weekends" 
                        label="Valid on Weekends?" 
                        checked={this.state.weekends} 
                        onChange={() => this.setState({weekends: !this.state.weekends})} 
                    />
                    <StyledCheckbox 
                        name="showDailyResult" 
                        label="Show Daily Result" 
                        checked={this.state.showDailyResult} 
                        onChange={() => this.setState({showDailyResult: !this.state.showDailyResult})} 
                    />
                    <StyledCheckbox 
                        name="useRealTime" 
                        label="Use Real Time Data" 
                        checked={this.state.useRealTime} 
                        onChange={() => this.setState({useRealTime: !this.state.useRealTime})} 
                    />
                </div>
                {
                    isBus
                    ? <div className="form-element-horizontal">
                        <label>Routes</label>
                        <MultiSelect 
                            name="routesSelected"
                            options={this.state.routes}
                            selected={this.state.routesSelected}
                            onChange={this.updateValue}
                            hasAllOption={true}
                            dataColumns={8}
                        />
                    </div>
                    : null
                }

                <div className="filter-bar">
                    <div className="option  " onClick={this.resetFilter}>Reset</div>
                    <div className="option  " onClick={this.applyFilter}>Apply Filter</div>
                </div>
            </div>
        )
    }
}